const config = {
  production: {
    iconBasePath: '/assets/',
    navicon: 'assets/icons/navbar/',
    userdetailicons: '/assets/icons/glass/',
    apiBaseUrl: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/cark/api/user_data`,
    apiBaseUrlCarkData: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/cark/api/cark_data`,
    apiBaseUrlCevir: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/cark/api/cevir`,
    apiBaseUrl3: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/cark/api/user_gecmis`,
    apiAdvanceUrl: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/api/advanced`,
    apiUserSearch: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/api/external/user`,
    apiSiraliistek: 'https://ozelydrm-api.slotdaybonus.xyz/api/sirali-istek',
    //apiSiraliistek: 'https://ozelydrm-api-test.slotdaybonus.xyz/api/sirali-istek',
    apiClaimUrl: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/api`,
    apiStyle: `https://${window.location.host}/api/`,
    apigameid: `${window.location.hostname.split('.')[0]}`,
    adminApi: `https://${"api." + window.location.host.split('.').splice(1).join('.')}/admin/api/`,
    appName: 'HookPanel',
    cfg: `https://${window.location.hostname.split('.')[0]}/admin/config.json`,
    imgUrl: `/logo.png`,
    sitekey:"6Le9PxYsAAAAABIZrkG0MWGsNo7g2gp7tA5bAok2", // Google reCAPTCHA v2 Site Key
    
  }
};



const env = 'production';
export default config[env];

